export default __webpack_public_path__ + "static/media/deletedraft.8ae9bddb.svg";